import { Callout, Flex, Icon, Link } from '@scale/scaleui-radix';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

const ClaimHostsCallout = () => {
  return (
    <Callout.Root size="1" color="info">
      <Callout.Icon>
        <Icon icon={faInfoCircle} size="2" label="Information" />
      </Callout.Icon>
      <Flex direction="row" gap="2" align="center">
        <Callout.Text>
          Please always remember to claim host at the start of your Zoom meeting. See instructions{' '}
          <Link
            href="https://scale.atlassian.net/wiki/spaces/OP/pages/936575062/Webinar+Sessions#Claiming-Host"
            target="_blank"
            rel="noopener noreferrer"
          >
            here.
          </Link>
        </Callout.Text>
      </Flex>
    </Callout.Root>
  );
};

export default ClaimHostsCallout;
